import CRMApplication from './pie-sales-crm'
import { ThemeProvider } from './theme/ThemeProvider'
import './App.css'

function App() {
  return (
    <ThemeProvider>
      <CRMApplication />
    </ThemeProvider>
  )
}

export default App
